import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useQuery } from '@apollo/client';
import { useRouteMatch } from 'react-router-dom';
import { ModuleProps } from '../../../../types';

import PageContainer from 'components/@layout/PageContainer';
import HeaderBar from 'components/ClassroomsModule/ClassroomDetails/HeaderBar';
import DetailBar from './components/DetailBar';
import ListViewContainer from './components/ListViewContainer';

import GET_CLASSROOM from 'graph/classroom/get-admin-classroom-details';
import useStudentActionOptionsMenu from 'hooks/use-student-action-options-menu';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      padding: theme.spacing(5)
    }
  };
});

const AdminClassesStudentsDetails: React.FC<ModuleProps> = props => {
  const match = useRouteMatch<{ classroomId: string }>();
  const classroomId = Number(match.params.classroomId);
  const [headerLoader, setLoading] = React.useState(false);
  const { data, loading } = useQuery(GET_CLASSROOM, {
    variables: {
      where: {
        id: classroomId
      }
    }
  });

  const { actionOptions, loading: studentMutationLoading } = useStudentActionOptionsMenu({
    translationId: 'Classroom',
    classroomId,
    classroom: data?.classroom
  });

  const classes = useStyles();

  return (
    <PageContainer loading={headerLoader || loading || studentMutationLoading}>
      <HeaderBar
        classroom={data?.classroom || {}}
        setLoading={setLoading}
        {...props}
        getTitle={(): string => data?.classroom?.name || ''}
      />
      <div className={classes.container}>
        <DetailBar classroom={data && data.classroom} />
        <ListViewContainer
          classroom={data && data.classroom}
          students={data && data.classroom?.students}
          actionOptions={actionOptions}
        />
      </div>
    </PageContainer>
  );
};

export default AdminClassesStudentsDetails;
